import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { gql } from 'glimmer-apollo';
import config from 'embroil/config/environment';

export default class LiveStreams extends Service {
  @tracked streams = [];
  @tracked loading = false;
  @tracked error = null;

  async fetchStreams(context = { type: 'FAVORITES' }) {
    this.loading = true;
    this.error = null;
    
    try {
      const query = gql`
        query TwitchStreams($context: LivestreamContextInput!) {
          livestreams(context: $context) {
            streams {
              id
              userId
              userName
              userDisplayName
              gameId
              gameName
              title
              viewerCount
              startedAt
              language
              thumbnailUrl
              profileImageUrl
              isLive
              tags
            }
            totalCount
          }
        }
      `;
      
      // Use fetch directly to GraphQL endpoint since this is a service not a component
      const response = await fetch(`${config.graphqlEndpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          query: query.loc.source.body,
          variables: { context }
        })
      });
      
      const result = await response.json();
      
      if (result.errors) {
        throw new Error(result.errors[0].message);
      }
      
      this.streams = result.data.livestreams.streams || [];
    } catch (error) {
      console.error('Error fetching Twitch streams:', error);
      this.error = error;
      this.streams = [];
    } finally {
      this.loading = false;
    }
  }

  get liveCount() {
    return this.streams?.length || 0;
  }
}
